import urlConfig from 'Url';

export const INIT_FLIGHT = 'INIT_FLIGHT';
export const SELECT_FLIGHT = 'SELECT_FLIGHT';
export const CLEAR_FLIGHT = 'CLEAR_FLIGHT';
export const REST_FLIGHT = 'REST_FLIGHT';
export const CLEAR_LITS = 'CLEAR_LITS';
export const FIND_FLIGHT_LIST = 'FIND_FLIGHT_LIST';
export const GET_CHANGE_COST = 'GET_CHANGE_COST';
export const SAVE_WQT_OBJ = 'SAVE_WQT_OBJ';
export const SAVE_FILTER_FLIGHT = 'SAVE_FILTER_FLIGHT';
export const GET_FILTER_RULES = 'GET_FILTER_RULES';
export const GET_PRODUCTSHOW_LIST = 'GET_PRODUCTSHOW_LIST';

// 查询新航班(自愿变更)
export function findFlightList(data, originFlight) {
  return {
    type: FIND_FLIGHT_LIST,
    originFlight,
    payload: {
      request: {
        url: urlConfig.changeReqNewFlightDetail,
        method: 'post',
        data,
      },
    },
  };
}

// 初始化新航班相关数据
export function initFlight() {
  return { type: INIT_FLIGHT };
}

// 重新确认选择的航段
export function restFlight(key = '') {
  return { type: REST_FLIGHT, key };
}

// 选择航段
export function selectFlightData(data, flag, key = '') {
  return { type: SELECT_FLIGHT, data, flag, key };
}

// 清空选择的航段
export function clearFlight(key = '') {
  return { type: CLEAR_FLIGHT, key };
}

// 保存湾区通数据
export function saveWQT(wqtObj) {
  return { type: SAVE_WQT_OBJ, wqtObj };
}

// 使用条件
export function getFlightRules(data) {
  return {
    type: GET_FILTER_RULES,
    payload: {
      request: {
        url: urlConfig.getFlightRules,
        method: 'post',
        data,
      },
    },
  };
}

//固定里程使用条件
export function getMilageFlightRules(data) {
  return {
    type: GET_FILTER_RULES,
    payload: {
      request: {
        url: urlConfig.getMilageFlightRules,
        method: 'post',
        data,
      },
    },
  };
}



// WEBPACK FOOTER //
// ./src/routes/routes/ticketChanges/modules/actions.js